import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import {
  ExpandMore as ExpandMoreIcon,
  Telegram as TelegramIcon,
  PermPhoneMsgOutlined as PermPhoneMsgOutlinedIcon,
} from "@material-ui/icons";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import StyledButton from "../../components/core/StyledButton";

// context
import { useUserState } from "../../context/UserContext";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: "73vw",
      margin: "auto",
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down("xs")]: {
        width: "86.7vw",
        marginTop: theme.spacing(3),
      },
    },
    paper: {
      borderRadius: 5,
      boxShadow: "0 4px 15px 0 rgba(172, 172, 172, 0.25)",
    },
    title: {
      ...theme.typography.h1,
      marginTop: theme.spacing(5),
      color: "black",
      textAlign: "center",
      // TODO: font not align
      [theme.breakpoints.down("xs")]: {
        ...theme.typography.h1,
        marginTop: theme.spacing(0),
      },
    },
    subtitle: {
      ...theme.typography.h3,
      color: theme.palette.primary.main,
    },
    description: {
      ...theme.typography.h4,
    },
    cardSection: {
      marginTop: theme.spacing(2),
      padding: "28px 40px",
      position: "relative",
      [theme.breakpoints.down("xs")]: {
        padding: "28px 20px",
      },
    },
    cardSectionSmall: {
      height: 150,
    },
    accordions: {
      marginTop: theme.spacing(3),
    },
    heading: {
      ...theme.typography.h4,
      color: theme.palette.common.grey[600],
    },
    details: {
      fontSize: 14,
      lineHeight: 1.71,
      letterSpacing: 0.15,
    },
    tel: {
      height: 156,
      [theme.breakpoints.down("sm")]: {
        height: "100%",
      },
    },
    service: {
      height: 260,
      [theme.breakpoints.down("sm")]: {
        height: "100%",
      },
    },
    sideSection: {
      [theme.breakpoints.up("md")]: {
        marginBottom: 100,
      },
    },
    form: {
      marginTop: theme.spacing(2),
      position: "relative",
    },
    formItem: {
      width: "100%",
      marginBottom: theme.spacing(3),
      zIndex: 2,
    },
    MuiAccordionroot: {
      "&.MuiAccordion-root:before": {
        backgroundColor: "transparent",
      },
    },
    rightSideSection: {
      paddingLeft: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        paddingLeft: theme.spacing(0),
        marginTop: theme.spacing(2),
      },
    },
    contactInfoText: {
      ...theme.typography.h4,
      color: "black",
      marginTop: theme.spacing(2),
    },
    submitButton: {
      ...theme.typography.subtitle2,
      fontWeight: 500,
      // marginTop: theme.spacing(2),
      width: 85,
      height: 40,
      borderRadius: theme.spacing(2.5),
      backgroundColor: theme.palette.common.grey[300],
      color: "white",
      "&.MuiButton-root.Mui-disabled": {
        color: "white",
      },
    },
    submit: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-start",
    },
    submitButtonActive: {
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    icon: {
      color: theme.palette.primary.light,
      fontSize: "10rem",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    iconSm: {
      fontSize: "7rem",
    },
    iconBackground: {
      position: "absolute",
      right: theme.spacing(1),
      bottom: theme.spacing(2),
    },
    iconBackgroundSpecial: {
      bottom: theme.spacing(-1),
    },
  }),
);

const ContactUs = props => {
  const classes = useStyles();

  const { platform } = useUserState();
  const { email = "", tel = "" } = platform;

  const mockData = [
    {
      summary: "1. 如何觀看視界影視文化平台的影片？",
      details:
        "我們提供團體訂閱方案，登入後即可使用視界影視文化平台的服務。若是個人使用，我們也有與其他平台合作，若您有這些平台的會員帳號，也可自平台登入觀看影片。合作平台：國家圖書館-公共圖書館區域資源中心電影院、國立臺灣圖書館電影院等等。",
    },
    {
      summary: "2. 地區不支援？",
      details: "目前視界影視文化平台的服務只開放給台灣IP用戶，請海外用戶見諒。",
    },
    {
      summary: "3. 為什麼帳號閒置後會被登出？",
      details:
        "為維護電影版權，視界影視文化平台帳號有團體佔位機制，若同一帳號使用者已經達到上限、且您開啟頁面後超過30分鐘未播放影片，我們會將您的帳號讓給新登入者使用。附註：平台不會將正在播放的使用者帳號登出，只會將閒置的帳號登出",
    },
    {
      summary: "4. 帳號如達使用上限人數該怎麼辦？",
      details:
        "達使用人數上限後，則會跳出「授權數量不足」視窗，需要等前面的使用者退出觀看正片後，才可觀看電影正片。您可透過右上角帳號下拉選單查看剩餘佔位數，若有需要購入更多使用帳號請聯絡客服人員。",
    },
    {
      summary: "5. 如帳號相隔一段時間沒使用，被登出後如何再次登入使用？",
      details:
        "如您是欲使用「IP驗證登入」，重整平台頁面後，系統將會自動判別IP登入，即可觀看電影正片。也可以手動點選右上角註冊/登入，點選IP自動登入。如您是欲使用「合作平台登入」，可從校園或圖書館內提供的合作平台頁面輸入帳號密碼後，登入即可觀看電影正片。若還是無法登入，可以刪除教室電影院的網頁瀏覽紀錄，重新從合作平台登入，即可正常使用平台。",
    },
  ];

  return (
    <div>
      <div className={classes.root}>
        <Grid container justify='center' alignItems='center' spacing={2}>
          <Grid item xs={12}>
            <div className={classes.title}>
              有任何使用上的疑問，請聯絡我們。
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.description}>
              教室電影院客服團隊服務時間為週一至週五
              10:00-18:00，不含國定假日。歡迎透過郵件聯絡，我們會儘速回覆您！
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classNames(classes.cardSection, classes.paper)}>
              <div className={classes.subtitle}>常見問題</div>
              <div className={classes.accordions}>
                {mockData.map((item, idx) => (
                  <Accordion
                    key={`accordion-${idx}`}
                    elevation={0}
                    classes={{
                      root: classes.MuiAccordionroot,
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-content-${idx}`}
                      id={`panel-header-${idx}`}
                    >
                      <Typography className={classes.heading}>
                        {item.summary}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.details}>
                        {item.details}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} className={classNames(classes.sideSection)}>
            <Paper
              className={classNames(
                classes.cardSection,
                classes.cardSectionSmall,
                classes.paper,
              )}
            >
              <div>
                <div className={classes.subtitle}>電子郵件</div>
                <div
                  className={classNames(
                    classes.iconBackgroundSpecial,
                    classes.iconBackground,
                  )}
                >
                  <TelegramIcon className={classes.icon} />
                </div>
              </div>
              <div className={classes.submit}>
                <StyledButton
                  component='a'
                  href={email ? `mailto:${email}` : ""}
                  variant={email === "" ? "inactive" : "default"}
                >
                  寄信給我們
                </StyledButton>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} className={classNames(classes.sideSection)}>
            <Paper
              className={classNames(
                classes.cardSection,
                classes.cardSectionSmall,
                classes.paper,
              )}
            >
              <div>
                <div className={classes.subtitle}>電話</div>
                <div className={classes.contactInfoText}>{tel}</div>

                <div className={classes.iconBackground}>
                  <PermPhoneMsgOutlinedIcon
                    className={classNames(classes.iconSm, classes.icon)}
                  />
                </div>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

ContactUs.defaultProps = {};

ContactUs.propsTypes = {};

export default ContactUs;
